import { z } from 'zod';
export const PAGINATION_DEFAULT_PAGE = 1;
export const PAGINATION_DEFAULT_LIMIT = 20;
export const PAGINATION_MIN_PAGE = 1;
export const PAGINATION_MIN_LIMIT = 1;
export const PAGINATION_MAX_LIMIT = 100;
export const paginationSchema = z.object({
    page: z.number().int().min(PAGINATION_MIN_PAGE).default(PAGINATION_DEFAULT_PAGE),
    limit: z
        .number()
        .int()
        .min(PAGINATION_MIN_LIMIT)
        .max(PAGINATION_MAX_LIMIT)
        .default(PAGINATION_DEFAULT_LIMIT),
});
